import { useConfig } from 'wagmi'

import type { Chain } from '../configs/chains/chain.config'

export function useChains(): Chain[] {
  const { chains } = useConfig()
  return chains as [Chain, ...Chain[]]
}
